<template lang="pug">
  v-container#dashboard(tag='section')
    v-row(class="pa-3")
      v-menu(v-model='menu', :close-on-content-click='false', :nudge-width='200', nudge-top offset-x='')
        template(v-slot:activator='{ on }')
          v-btn(color='secondary', dark='', v-on='on' style="height: 48px;").mt-0
            v-icon mdi-calendar
            p filter by dates
        v-card(style="border:3px solid #3cbbc2;").pa-2
          DateFilter(@closeMenu="filterSummary($event)" :currentType='currentType',)
      .text-center(style="display:flex; align-items:center;")
      h1(class='ml-9') {{from ? 'From ' + from + ' to ' + to + ' you had: ': '' }}
      v-spacer
      v-btn(@click="filterSummary(null)" tile='' outlined='' small color='#008E95').mx-2
        v-icon(left='' small) mdi-refresh
        p Get all users
      .text-center(style="display:flex; align-items:flex-start;").mt-2
    v-row.justify-center
      v-col(cols='12' md='6')
        v-skeleton-loader.mx-auto(:transition='transition' v-if='summary.registrations.isLoading'  type='card')
        base-material-chart-card(v-else :data='summary.registrations'  :options='options' color='primary'  type='Bar')
          h3.card-title.font-weight-light.mt-2.ml-2
            | {{from ? '': 'Registered users in last 7 days: ' + totalRegisteredofWeek }}
    v-row.justify-center
      v-col(cols='6' sm='6')
        v-skeleton-loader.mx-auto(tile type='list-item-avatar-two-line' transition='scale-transition' v-if='summary.registrations.isLoading' max-width='250' )
        base-material-stats-card(v-else color='primary' icon='mdi-poll' :title="'Total registered users'" :value='from ? summary.registrations.total : registrations.length+""' sub-icon='mdi-card' sub-text='')
    v-row
      v-col(cols-12)
        usersListComponent(:lists="usersList")
</template>

<script>
  import moment from 'moment'
  import Chartist from 'chartist'
  import 'chartist/dist/chartist.min.css'
  import ChartistTooltip from 'chartist-plugin-tooltip'

  export default {
    name: 'DashboardDashboard',
    inject: ['theme'],
    components: {
      DateFilter: () => import('@/components/custom/filters/DateFilterMetrics'),
      usersListComponent: () => import('./UsersList'),
    },
    filters: {
      moment (date) {
        return moment(date).format('MM-DD-YYYY hh:mm A')
      },
    },
    data () {
      return {
        totalRegisteredofWeek: 0,
        totalRegisteredofMonth: 0,
        transition: 'scale-transition',
        summary: {
          registrations: {
            labels: [],
            series: [],
            isLoading: true,
          },
        },
        menu: false,
        currentType: 'loadFilteredSummary',
        from: null,
        to: null,
        preset: '',
        usersList: [],
      }
    },
    computed: {
      headers () {
        return [
          {
            sortable: true,
            text: 'First Name',
            value: 'profile.name',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Last Name',
            value: 'profile.lastName',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Email',
            value: 'email',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Phone',
            value: 'profile.phone',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Registration Date',
            value: 'createdAt',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Subscription',
            value: 'plan.name',
            align: 'left',
          },
          {
            sortable: false,
            text: 'Actions',
            value: 'actions',
            align: 'left',
          },
        ]
      },
      options () {
        return {
          lineSmooth: Chartist.Interpolation.cardinal({
            tension: 0,
          }),
          low: 0,
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
          showPoint: true,
          plugins: [
            ChartistTooltip(),
          ],
        }
      },
      registrations () {
        return this.$store.getters['summary/getRegistrations']
      },
    },
    created () {
      this.getAllRegistrations(null, null, null)
    },
    methods: {
      replyContact (item) {
        window.location.href = `mailto:${item.email}?subject=Contact From Tender Team`
      },
      getAllRegistrations (from, to, preset) {
        const vm = this
        vm.summary.registrations.isLoading = true
        vm.$store.dispatch('summary/getAllRegistrations', { from: from, to: to, preset: preset }).then((res) => {
          // console.log(res,"RES DE ALLSUBSCRIPTIONS")
          vm.usersList = res
          if (from && to && preset) {
            vm.summary.registrations.labels = Object.keys(res.data)
            vm.summary.registrations.series = [Object.values(res.data)]
            vm.summary.registrations.total = res.length.toString()
            vm.summary.registrations.isLoading = false
          } else {
            vm.getRegisterPerDays(res)
          }
        })
      },
      async getRegisterPerDays (response) {
        const vm = this
        const date = new Date()
        const actualDate = date.getDay()
        let daysOfTheWeek = [0, 0, 0, 0, 0, 0, 0]
        let registersPerDays = [0, 0, 0, 0, 0, 0, 0]
        await daysOfTheWeek.forEach((day, index) => {
          day = (actualDate - index + 7) % 7
          const d = new Date()
          d.setDate(date.getDate() - index)
          let start = d
          start.setHours(0, 0, 0, 0)
          start = start.getTime()
          let end = d
          end.setHours(23, 59, 59, 999)
          end = end.getTime()
          const registers = this.registrations.filter(registration => registration.createdAt > start && registration.createdAt < end)
          registersPerDays[index] = registers.length
          switch (day) {
            case 0:
              daysOfTheWeek[index] = 'Sunday'
              break
            case 1:
              daysOfTheWeek[index] = 'Monday'
              break
            case 2:
              daysOfTheWeek[index] = 'Tuesday'
              break
            case 3:
              daysOfTheWeek[index] = 'Wednesday'
              break
            case 4:
              daysOfTheWeek[index] = 'Thursday'
              break
            case 5:
              daysOfTheWeek[index] = 'Friday'
              break
            case 6:
              daysOfTheWeek[index] = 'Saturday'
              break
          }
        })
        daysOfTheWeek = daysOfTheWeek.reverse()
        vm.summary.registrations.labels = daysOfTheWeek
        registersPerDays = registersPerDays.reverse()
        vm.summary.registrations.series[0] = registersPerDays
        vm.totalRegisteredofWeek = registersPerDays.reduce((a, b) => a + b, 0)
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1).getTime()
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).getTime()
        const registers = vm.registrations.filter(registration => registration.createdAt > firstDay && registration.createdAt < lastDay)
        vm.usersList = vm.registrations
        vm.totalRegisteredofMonth = registers.length
        vm.summary.registrations.isLoading = false
      },
      filterSummary (dates) {
        const vm = this
        let preset = null
        if (dates) {
          vm.menu = false
          vm.from = moment(dates.from).format('MM-DD-YYYY')
          vm.to = moment(dates.to).format('MM-DD-YYYY')
          const momentFrom = moment(dates.from)
          const momentTo = moment(dates.to)
          const differenceInDays = momentTo.diff(momentFrom, 'days')
          if (differenceInDays === 1) {
            preset = 'today'
          } else if (differenceInDays <= 7) {
            preset = 'week'
          } else if (differenceInDays <= 31) {
            preset = 'month'
          } else {
            preset = 'year'
          }
        } else {
          vm.from = null
          vm.to = null
        }
        vm.getAllRegistrations(vm.from, vm.to, preset)
      },
    },
  }
</script>
